import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO/SEO";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

// Import team data
import Teams from "../../api/team";

import bgLarge from "../../images/team/noice-bg02.png";
import bgSmall from "../../images/team/noice-bg.png";
import pricingBg from "../../images/bg/pricing-bg.png";

const TeamPage: React.FC = () => {
  const { t } = useTranslation();

  // Mark HYPERION and LINK as featured (big cards)
  const featuredSlugs = ['hyperion', 'link'];

  return (
    <Fragment>
      <SEO title="AI Characters" description="Meet AXOIX's 22 AI characters — HYPERION, FORGE, LEDGER, KEEPER, LINK, CHORUS, BARTER, VOYAGE, and more. Each specializes in a different business function." path="/team" />
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
            <main
              style={{
                backgroundImage: `url(${pricingBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center top",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "fixed",
              }}
            >
            <PageTitle pageTitle={t('team.subtitle')} pagesub={t('team.pageSubtitle')} />
            <section className="team pt-70 pb-100">
              <div className="container">
                <div className="sec-title sec-title-center text-center mb-45">
                  <span className="sub-title mb-20">{t('team.yourCrew')}</span>
                  <h2 className="title title-line_height">
                    {t('team.pageTitle')}
                  </h2>
                  <p className="mt-20 opacity-75" style={{ maxWidth: '800px', margin: '0 auto' }}>
                    {t('team.pageDescription')}
                  </p>
                </div>

                <div className="row mt-none-30">
                  {Teams.map((member) => {
                    const isFeatured = featuredSlugs.includes(member.slug);
                    return (
                      <div
                        key={member.id}
                        className={
                          isFeatured
                            ? "col-xl-6 col-lg-6 col-md-8 mt-30"
                            : "col-xl-4 col-lg-4 col-md-6 col-sm-6 mt-30"
                        }
                      >
                        <div
                          className={
                            isFeatured
                              ? "xb-team-item xb-team-item-big xb-border"
                              : "xb-team-item xb-border"
                          }
                        >
                          <div className="xb-item--img">
                            <img src={member.tImg} alt={member.name} />
                          </div>

                          <div className="xb-item--holder ul_li_between">
                            <div className="xb-item--author">
                              <h2 className="xb-item--name">{member.name}</h2>
                              <span className="xb-item--desig">{member.title}</span>
                            </div>

                            <span className="xb-item--social xb-border">
                              <i className={member.slug === 'link' ? 'fas fa-phone-alt' : 'fas fa-robot'}></i>
                            </span>
                          </div>

                          <div className="xb-bg">
                            <img src={isFeatured ? bgLarge : bgSmall} alt="background" />
                          </div>
                        </div>

                        {/* Description Card Below */}
                        <div className="xb-border mt-10 p-20" style={{ borderRadius: '15px', background: 'rgba(15, 20, 40, 0.6)' }}>
                          <p className="mb-10" style={{ fontSize: '14px', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.85)' }}>
                            {member.description}
                          </p>
                          <div className="d-flex flex-wrap gap-2">
                            {member.capabilities.slice(0, isFeatured ? 5 : 3).map((cap, idx) => (
                              <span
                                key={idx}
                                className="xb-border px-3 py-1"
                                style={{ fontSize: '12px', borderRadius: '20px', opacity: 0.8 }}
                              >
                                {cap}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* CTA Section */}
                <div className="text-center mt-70">
                  <div className="xb-border p-40" style={{ borderRadius: '20px', background: 'rgba(138,43,226,0.05)' }}>
                    <h3 className="mb-15">{t('team.ctaTitle')}</h3>
                    <p className="opacity-75 mb-25">
                      {t('team.ctaDescription')}
                    </p>
                    <a href="/signup" className="thm-btn agency-btn">
                      <span className="text">{t('hero.cta')}</span>
                      <span className="arrow">
                        <span className="arrow-icon">
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
                            <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
                            <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
                            <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
                            <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
                            <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
                            <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
                          </svg>
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
                            <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
                            <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
                            <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
                            <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
                            <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
                            <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
                          </svg>
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default TeamPage;
